module.exports = __webpack_public_path__ + "static/media/attendance.0f1553f6.svg";